import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPaperclip,
  faSmile,
} from "@fortawesome/free-solid-svg-icons";
import "../Styles/ADCGridCentreLayout.css"; // CSS for styling
import "../Styles/ADCGridLeftLayout.css";

const mockMessages = [
  {
    id: 1,
    sender: "Alice",
    message: "Hey! How are you?",
    timestamp: "2025-03-08T10:30:00",
  },
  {
    id: 2,
    sender: "User",
    message: "I'm good! Just finished my work. What about you?",
    timestamp: "2025-03-08T10:35:00",
  },
  {
    id: 3,
    sender: "Alice",
    message: "That's great! I'm planning a trip this weekend.",
    timestamp: "2025-03-09T14:00:00",
  },
  {
    id: 4,
    sender: "User",
    message: "Nice! Where are you going?",
    timestamp: "2025-03-09T14:10:00",
  },
];

// Function to group messages by date
const groupMessagesByDate = (messages) => {
  return messages.reduce((acc, msg) => {
    const date = new Date(msg.timestamp).toDateString();
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(msg);
    return acc;
  }, {});
};

export const RenderGroupConversationContent = ({
  submode,
  searchTerm,
  conversations }) => {

      const [messages, setMessages] = useState(mockMessages);
      const [newMessage, setNewMessage] = useState("");
      const messagesEndRef = useRef(null); // Reference to scroll to bottom


        // Scroll to the bottom when messages change
        useEffect(() => {
          messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
        }, [messages]);
      
        // Function to send a message
        const sendMessage = () => {
          if (newMessage.trim() === "") return;
      
          const newMsg = {
            id: messages.length + 1,
            sender: "User",
            message: newMessage,
            timestamp: new Date().toISOString(),
          };
      
          setMessages([...messages, newMsg]);
          setNewMessage("");
        };
      
        const groupedMessages = groupMessagesByDate(messages);

    return (
      <div style={{display: "flex", flexDirection: "column"}}>
        {submode === "groupchat" && (
          <div>             
            <div className="adc-message-display" >
            {Object.keys(groupedMessages).map((date) => (
              <div key={date}>
                <div className="uac-date-separator">{date}</div>
                  {groupedMessages[date].map((msg) => (
                  <div
                    key={msg.id}
                    className={`message-bubble ${msg.sender === "User" ? "sent" : "received"}`}
                    style={{color: "black"}}
                  >
                    <div className="message-text" style={{color: "black"}}>{msg.message}</div>
                    <div className="message-time" style={{color: "black"}}>
                      {new Date(msg.timestamp).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
                    </div>
                  </div>
                  ))}
                </div>
                ))}
              <div ref={messagesEndRef} />
            </div>

            <div className="uac-message-input" style={{width: 500, height: 100, marginTop: 20, borderRadius: 10 }}>              
              <input
                style={{width: 350, color: "black", marginLeft: 10}}
                type="text"
                placeholder="Type your message..."
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
              />

              {/* <button style={{width: 30, background: "red", color: "black"}}>  
                <faSmile size={20} color={"black"}/>
              </button> */}
              {/* <button className="icon-button" style={{width: 40, color: "black", background: "pink", marginLeft: 0}}>
                <faPaperclip size={20} />
              </button> */}
              <button className="send-button" onClick={sendMessage} style={{width: 70, marginLeft: 20, marginTop: 10}}>Send</button>
            </div>
          </div>
        )}

        {submode === "searchkey" && (
          <div>
            <h4>Search Results for "{searchTerm}"</h4>
            <ul className="message-list">
              {conversations?.conversations?.flatMap((conversation) =>
                conversation.allmessages?.flatMap((entry) =>
                  entry.messages
                    ?.filter((msg) =>
                      msg.content.toLowerCase().includes(searchTerm.toLowerCase())
                    )
                    .map((msg) => (
                      <li key={msg.id} className="message-item">
                        <strong>{msg.sender}</strong>: {msg.content}
                      </li>
                    ))
                )
              )}
            </ul>
          </div>
        )}

        {submode === "memberchat" && (
          <div>
            <h4>Member Chat Mode</h4>
            <p>This section could display a list of members to message individually.</p>
          </div>
        )}
      </div>
    );
};

export default RenderGroupConversationContent;